import React from "react";
import { Icon, Typography } from "../../../../ecosystem";

const SummaryItemFile = ({
    fileName,
    fileSize,
    isMobile
}) => {

    const formatFileSize = (size) => {
        let toKB = Math.round(size / 1024);
        if (toKB >= 1024) {
            let toMB = (toKB / 1024).toFixed(2);
            return `${toMB} MB`
        }
        return `${toKB} KB`
    }

    return (
        <div className="care-gaps-summary-item__content care-gaps-summary-item__content--file">
            <div className="care-gaps-summary-item__content-icon">
                <Icon name="attachment" />
            </div>
            {fileName && 
                <div className="care-gaps-summary-item__content-file-name">
                    <Typography
                        bold
                        color="$color-secondary-a2"
                        type="heading-01"
                        tag="div"
                    >{fileName}
                    </Typography>
                </div>
            }
            {fileSize && 
                <div className="care-gaps-summary-item__content-file-size">
                    <Typography
                        color={"$color-secondary-a3"}
                        type="heading-01"
                        tag="div"
                    >{formatFileSize(fileSize)}
                    </Typography>
                </div>
            }
        </div>
    );
};

export default SummaryItemFile;